module.exports = __webpack_public_path__ + "logo.svg?f51946db8efe3ac932501abfd3cc3eac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 75
// module chunks = 0